var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaSoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.884766,
    y: 0.000244141,
    width: 23.8847,
    height: 23.9995,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66536 4.00024C7.0927 4.00024 5 6.09488 5 8.66821V15.3349C5 17.9075 7.09464 20.0002 9.66797 20.0002H16.3346C18.9073 20.0002 21 17.9056 21 15.3323V8.66561C21 6.09294 18.9054 4.00024 16.332 4.00024H9.66536ZM17.6667 6.66691C18.0347 6.66691 18.3333 6.96558 18.3333 7.33358C18.3333 7.70158 18.0347 8.00024 17.6667 8.00024C17.2987 8.00024 17 7.70158 17 7.33358C17 6.96558 17.2987 6.66691 17.6667 6.66691ZM13 8.00024C15.206 8.00024 17 9.79424 17 12.0002C17 14.2062 15.206 16.0002 13 16.0002C10.794 16.0002 9 14.2062 9 12.0002C9 9.79424 10.794 8.00024 13 8.00024ZM13 9.33358C12.2928 9.33358 11.6145 9.61453 11.1144 10.1146C10.6143 10.6147 10.3333 11.293 10.3333 12.0002C10.3333 12.7075 10.6143 13.3858 11.1144 13.8859C11.6145 14.386 12.2928 14.6669 13 14.6669C13.7072 14.6669 14.3855 14.386 14.8856 13.8859C15.3857 13.3858 15.6667 12.7075 15.6667 12.0002C15.6667 11.293 15.3857 10.6147 14.8856 10.1146C14.3855 9.61453 13.7072 9.33358 13 9.33358Z",
    fill: "#80899C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaSoc);
export default __webpack_public_path__ + "static/media/insta_soc.7908736107fa001ddf927f79518eaf8a.svg";
export { ForwardRef as ReactComponent };